/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20019
     */
    checkoutUrl: string;
}

export function InlineResponse20019FromJSON(json: any): InlineResponse20019 {
    return InlineResponse20019FromJSONTyped(json, false);
}

export function InlineResponse20019FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20019 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkoutUrl': json['checkoutUrl'],
    };
}

export function InlineResponse20019ToJSON(value?: InlineResponse20019 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkoutUrl': value.checkoutUrl,
    };
}


